import Link from '@alltrails/denali/components/Link';
import { FormattedMessage } from 'react-intl';
import Typography from '@alltrails/core/components/Typography';
import styles from '../../../components/OldPressCard/styles/styles.module.scss';
import { OldPressReleaseCard } from '@/components/OldPressCard';

const allTrailsDotComLink = (
  <Link href="/" target="_blank">
    AllTrails.com
  </Link>
);

const pressRelease: OldPressReleaseCard = {
  cardType: 'press-release',
  title: <FormattedMessage defaultMessage="AllTrails Introduces Photo Gallery" />,
  date: 'May 7, 2024',
  modalContent: (
    <>
      <Typography variant="heading400" component="h2">
        <FormattedMessage defaultMessage="AllTrails Introduces Photo Gallery" />
      </Typography>
      <Typography variant="heading200" component="h3">
        <FormattedMessage defaultMessage="New in-app photo experience helps members picture the adventures ahead" />
      </Typography>
      <Typography variant="paragraph100">
        <FormattedMessage defaultMessage="San Francisco (May 7, 2024) — AllTrails, the world's largest and most trusted platform for outdoor exploration, today launched Photo Gallery, an in-app experience that allows members to visually tour hundreds of thousands of trails around the globe. Featuring photos from AllTrails’ community of more than 65 million members, Photo Gallery offers inspiring and informative previews to help trail-goers plan their next adventure." />
        <br />
        <FormattedMessage defaultMessage="Photo Gallery lets members:" />
        <ul>
          <li>
            <FormattedMessage defaultMessage="Tour the trail through photos taken at different points along the route" />
          </li>
          <li>
            <FormattedMessage defaultMessage="View popular trail sights, such as summit vistas, waterfalls, and historical landmarks" />
          </li>
          <li>
            <FormattedMessage defaultMessage="Get a glimpse of changes on the trail throughout the seasons" />
          </li>
          <li>
            <FormattedMessage defaultMessage="See the most recently documented trail conditions" />
          </li>
        </ul>
        <br />
        <FormattedMessage defaultMessage="“Millions of people use AllTrails to explore the outdoors and share their experiences with our community.” said Ivan Selin, Chief Product Officer at AllTrails. “Photo Gallery offers an immersive tour of your next trail. It helps you know what to expect and get ready for your next adventure.”" />
        <br />
        <Typography variant="text100bold">
          <FormattedMessage defaultMessage="About AllTrails" />
        </Typography>
        <br className={styles.noMargin} />
        <FormattedMessage
          defaultMessage="AllTrails helps you find your outside with inspiration from a global community of trail-goers. We connect people to the outdoors, help them discover new places, and elevate their experiences on the trail. AllTrails was awarded Apple’s 2023 iPhone App of the Year and a Google Play Best of 2023 honorable mention. Download AllTrails in the App Store or head to {allTrailsDotComLink} to learn more."
          values={{ allTrailsDotComLink }}
        />
      </Typography>
    </>
  )
};

export default pressRelease;
